<template>
  <div>
    <transition name="fade">
      <div v-if="!dataLoaded" class="rainbow-spinner">
        <md-progress-spinner class="spinner"  :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </transition>
    <transition name="fade">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <form v-if="dataLoaded">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Title &amp; Url</h5>
              </md-card-header>

              <md-card-content>
                <!-- Name -->
                <div class="md-layout">
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogTitle') },
                        {
                          'md-valid':
                            !errors.has('blogTitle') && touched.blogTitle
                        }
                      ]"
                    >
                      <label>Blog title</label>
                      <md-input
                        v-model="blog.Title"
                        data-vv-name="blogTitle"
                        type="text"
                        v-validate="modelValidations.blogTitle"
                        required
                        @change="blogTitleChanged()"
                      >
                      </md-input>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.Title, 120)}}</span>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('blogTitle')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="!errors.has('blogTitle') && touched.blogTitle"
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                  <!-- Meta Title -->
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogMetaTitle') },
                        {
                          'md-valid':
                            !errors.has('blogMetaTitle') &&
                            touched.blogMetaTitle
                        }
                      ]"
                    >
                      <label>Meta Title</label>
                      <md-input
                        v-model="blog.MetaTitle"
                        data-vv-name="blogMetaTitle"
                        type="text"
                        v-validate="modelValidations.blogMetaTitle"
                        required
                      >
                      </md-input>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.MetaTitle, 120)}}</span>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('blogMetaTitle')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogMetaTitle') &&
                              touched.blogMetaTitle
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                  <!-- Url Identifier -->
                  <div class="md-layout-item md-size-33">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogUrl') },
                        {
                          'md-valid': !errors.has('blogUrl') && touched.blogUrl
                        }
                      ]"
                    >
                      <label>Url identifier</label>
                      <md-input
                        v-model="blog.UrlTag"
                        data-vv-name="blogUrl"
                        type="text"
                        v-validate="modelValidations.blogUrl"
                        required
                      >
                      </md-input>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.UrlTag, 120)}}</span>
                      <slide-y-down-transition>
                        <md-icon class="error" v-show="errors.has('blogUrl')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="!errors.has('blogUrl') && touched.blogUrl"
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Content -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Blog Content</h5>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                        <editor
                          api-key="5g3ox6f5ymb9e6p8y7spzyu7xlt8lr5df3zpbvt475uryaf3"
                          v-model="blog.Content"
                          @onChange="blogContentChanged"
                          :init="{
                            height: 350,
                            menubar: false,
                            plugins: [
                              ' lists link image preview anchor',
                              'media table paste wordcount'
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic underline | color backcolor | \
                              alignleft aligncenter alignright alignjustify | link image | \
                              bullist numlist outdent indent | preview'
                          }"
                      />
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('blogContent')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogContent') &&
                              touched.blogContent
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Descriptions -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Short Description</h5>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50">
                    <!-- Description -->
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogDescription') },
                        {
                          'md-valid':
                            !errors.has('blogDescription') &&
                            touched.blogDescription
                        }
                      ]"
                    >
                      <label>Blog Description</label>
                      <md-textarea
                        v-model="blog.Description"
                        data-vv-name="blogDescription"
                        type="text"
                        v-validate="modelValidations.blogDescription"
                        style="height: 200px;"
                        required
                        @change="blogDescriptionChanged()"
                      ></md-textarea>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.Description, 550)}}</span>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('blogDescription')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogDescription') &&
                              touched.blogDescription
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                    <!-- Meta Description-->
                  <div class="md-layout-item md-size-50">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogMetaDescription') },
                        {
                          'md-valid':
                            !errors.has('blogMetaDescription') &&
                            touched.blogMetaDescription
                        }
                      ]"
                    >
                      <label>Meta Description</label>
                      <md-textarea
                        v-model="blog.MetaDescription"
                        data-vv-name="blogMetaDescription"
                        type="text"
                        v-validate="modelValidations.blogMetaDescription"
                        style="height: 200px;"
                        required
                      ></md-textarea>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.MetaDescription, 120)}}</span>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('blogMetaDescription')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogMetaDescription') &&
                              touched.blogMetaDescription
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Author & Meta Author -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Author</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <md-field :class="[
                        { 'md-error': errors.has('blogAuthor') },
                        {
                          'md-valid':
                            !errors.has('blogAuthor') &&
                            touched.blogAuthor
                        }
                      ]">
                      <label for="movie">Choose author</label>
                      <md-select 
                        v-model="blog.AuthorId" 
                        data-vv-name="blogAuthor"
                        @md-selected="authorChanged"
                        v-validate="modelValidations.blogAuthor"
                        >
                        <md-option :value="author.Id" v-for="author in authors" :key="author.Id">{{author.FirstName}} {{author.LastName}}</md-option>
                      </md-select>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('blogAuthor')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogAuthor') &&
                              touched.blogAuthor
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                  <div class="md-layout-item">
                    <md-field
                      :class="[
                        { 'md-error': errors.has('blogMetaAuthor') },
                        {
                          'md-valid':
                            !errors.has('blogMetaAuthor') &&
                            touched.blogMetaAuthor
                        }
                      ]"
                    >
                      <label>Meta Author</label>
                      <md-input
                        v-model="blog.MetaAuthor"
                        data-vv-name="blogMetaAuthor"
                        type="text"
                        v-validate="modelValidations.blogMetaAuthor"
                        required
                      >
                      </md-input>
                      <span class="md-helper-text">{{formatStringLimit(this.blog.MetaAuthor, 60)}}</span>
                      <slide-y-down-transition>
                        <md-icon
                          class="error"
                          v-show="errors.has('blogMetaAuthor')"
                          >close</md-icon
                        >
                      </slide-y-down-transition>
                      <slide-y-down-transition>
                        <md-icon
                          class="success"
                          v-show="
                            !errors.has('blogMetaAuthor') &&
                              touched.blogMetaAuthor
                          "
                          >done</md-icon
                        >
                      </slide-y-down-transition>
                    </md-field>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Tags -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Tags</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-chips
                      v-model="blog.Categories"
                      class="md-primary"
                      md-placeholder="Enter tag"
                    >
                    </md-chips>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Meta Keywords -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Meta Keywords</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-chips
                      v-model="blog.MetaKeywords"
                      class="md-primary"
                      md-placeholder="Enter keyword"
                      @md-insert="metaKeywordInserted"
                    >
                    </md-chips>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Status -->
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Status</h5>
              </md-card-header>
              <md-card-content class="md-card-content">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-switch v-model="blog.IsActive" @change="isActiveChanged()">
                      <span v-if="blog.IsActive"> <b>Active:</b> The blog is visible on the blogs page of vinozito.mk</span>
                      <span v-else> <b>Active:</b> The blog is hidden from the blogs page of vinozito.mk</span>  
                    </md-switch>
                    <md-switch v-model="blog.IsFeatured">
                      <span v-if="blog.IsFeatured"> <b>Featured:</b> The blog is visible on the home page of vinozito.mk</span>
                      <span v-else> <b>Featured:</b> The blog is hidden from the home page of vinozito.mk</span>  
                    </md-switch> 
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Photos -->
            <md-card v-if="blog.Photos.length">
              <md-card-header class="md-card-header-text md-card-header-green">
                <h5 class="title">Photos</h5>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 mt-20">
                    <div
                      class="file-input preview-image"
                      v-for="photo in blog.Photos"
                      :key="photo.Url"
                    >
                      <div class="image-container">
                        <img :src="photo.Thumbnail || photo.Url" />
                      </div>
                      <div class="button-container blog-buttons">
                        <md-button
                          class="md-xs md-simple md-just-icon "
                          @click="deletePhoto(photo)"
                          ><md-icon>delete</md-icon></md-button>
                        <md-button
                          class="md-xs md-simple md-just-icon "
                          @click="copyLink(photo)" :disabled="!photo.SocialThumbnail"><md-icon>link</md-icon>
                        </md-button>
                        <md-button
                          class="md-success md-xs md-simple md-just-icon"
                          v-if="isCoverPhoto(photo)"
                          ><md-icon>check_circle</md-icon></md-button
                        >
                        <md-button
                          class="md-xs md-simple md-just-icon"
                          v-else
                          @click="setCoverPhoto(photo)">
                          <md-icon>check_circle_outline</md-icon>
                        </md-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout">
                  <div class="md-layout-item md-size-50 mx-auto">
                    <md-progress-bar v-if="showPhotoLoading" class="md-accent" md-mode="query"></md-progress-bar>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Upload Photos -->
            <md-card>
              <md-card-content class="md-card-content" >
                <div class="md-layout">
                  <div class="md-layout-item md-size-100" style="padding:0;">
                    <vue-dropzone 
                      ref="myVueDropzone" 
                      id="dropzone"
                      :useCustomSlot="true"
                      v-on:vdropzone-files-added="vdropzoneFileAdded" 
                      v-on:vdropzone-success="vdropzoneSuccess"
                      :options="dropzoneOptions">
                        <div class="dropzone-custom-content">
                          <h4 class="dropzone-custom-title">Drag & drop to upload photos</h4>
                          <div class="subtitle">or click to select photos from your computer</div>
                        </div>
                      </vue-dropzone>
                  </div>
                </div>
              </md-card-content>
            </md-card>

            <!-- Submit Button -->
            <md-card class="md-card md-theme-default">
              <md-card-actions class="text-center">
                <md-button
                  native-type="submit"
                  @click.native.prevent="validate"
                  class="md-primary"
                  :disabled="!canSubmit || saving"
                  >
                  <md-progress-spinner v-if="saving" class="spinner" :md-diameter="20" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                  <span v-if="saving">&nbsp; Saving</span>
                  <span v-else> Save blog</span>
                  </md-button
                >
              </md-card-actions>
            </md-card>
          </form>
        </div>
      </div>
    </transition>

    <!-- Wizard -->
    <modal v-if="showPhotoWizard" class="photo-modal">
      <template slot="body">
        <md-card>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
                <simple-wizard style="width:800px" :nextDisabled="wizardNextDisabled" :saving="wizardSaving">
                  <template slot="header">
                    <h4 class="title">Prepare cover photo thumbnails</h4>
                    <md-button class="md-simple md-just-icon md-round modal-default-button" @click="photoModalHide">
                      <md-icon>clear</md-icon>
                    </md-button>
                   </template>

                  <!-- Step thumbnail -->
                  <wizard-tab :before-change="() => validateStep('step2')">
                    <template slot="label">
                      Thumbnail
                    </template>
                    <cropper
                      classname="cropper"
                      :src="editingPhoto.DataUrl"
                      v-if="editingPhoto"
                      :stencilProps="{
                        aspectRatio: 1 / 1
                      }"
                      @change="thumbChanged"
                    ></cropper>
                  </wizard-tab>
                  
                  <!-- Step social thumbnail-->
                  <wizard-tab :before-change="() => validateStep('step3')">
                    <template slot="label">
                      Social Thumbnail
                    </template>
                    <cropper
                      classname="cropper"
                      :src="editingPhoto.DataUrl"
                      v-if="editingPhoto && wizard.step2.valid"
                      :stencilProps="{
                        aspectRatio: 1.91 / 1
                      }"
                      @change="socialThumbChanged"
                    ></cropper>
                  </wizard-tab>
                </simple-wizard>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </template>
    </modal>
  </div>
</template>

<script>
import { SimpleWizard, WizardTab } from "@/components";
import axios from "axios";
import { Modal } from "@/components";
import { SlideYDownTransition } from "vue2-transitions";
import { Cropper } from "vue-advanced-cropper";
import Editor from '@tinymce/tinymce-vue';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import cdnInvalidator from "@/services/cdnInvalidator";

export default {
  components: {
    SimpleWizard,
    WizardTab,
    Modal,
    SlideYDownTransition,
    Cropper,
    vueDropzone: vue2Dropzone,
    editor: Editor
  },
  computed: {
    isEdit() {
      return this.blogId && this.blogId > 0;
    },
    isActive() {
      return this.blog.IsActive;
    },
    blogId() {
      return this.$route.params.id;
    },
    blogTitle() {
      return this.blog.Title;
    },
    blogDescription() {
      return this.blog.Description;
    },
    blogUrl() {
      return this.blog.UrlTag;
    },
    blogMetaTitle() {
      return this.blog.MetaTitle;
    },
    blogMetaDescription() {
      return this.blog.MetaDescription;
    },
    blogMetaAuthor() {
      return this.blog.MetaAuthor;
    },
    blogAuthor() {
      return this.blog.AuthorId;
    },
    canSubmit() {
      console.log(this.errors)
      return !!(
        !this.errors.has("blogTitle") &&
        !this.errors.has("blogDescription") &&
        !this.errors.has("blogUrl") &&
        !this.errors.has("blogMetaTitle") &&
        !this.errors.has("blogMetaDescription") &&
        !this.errors.has("blogMetaAuthor") &&
        this.blog.Content &&
        this.blog.AuthorId > 0 &&
        this.blog.Photos.length &&
        this.blog.CoverPhoto &&
        this.blog.MetaKeywords.length &&
        this.blog.Categories.length
      );
    }
  },
  mounted() {
    axios.get('api/Author').then(authors => {
      this.authors = authors.data
    })
    if (this.isEdit) {
      axios
        .get(`api/Blog/${this.blogId}`, {
          params: this.filters
        })
        .then(response => {
          this.blog = response.data;
        })
        .finally(() => {
           this.dataLoaded = true
        })
    } else {
      this.dataLoaded = true
    }
  },
  data() {
    return {
      authors: [],
      imageRegular: "",
      resizedFiles: {},
      photoButtonLoaders: {1: false, 2: false},
      showPhotoLoading: false,
      saving: false,
      wizardNextDisabled: false,
      wizardSaving: false,
      editingPhoto: {},
      dataLoaded: false,
      showPhotoWizard: false,
      editorToolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'header': 1 }, { 'header': 2 }], 
        ['bold', 'italic', 'underline', 'strike'], 
        [{ list: "ordered" }, { list: "bullet" }], 
        ['link', 'image'],
        [{ 'font': [] }],
        [{ 'align': [] }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'color': [] }, { 'background': [] }]
        ],
      dropzoneOptions: {
        url: (file) => {
          return file[0].Url
        },
        addRemoveLinks: false,
        resizeWidth: 1366,
        resizeHeight: 768,
        resizeQuality: 0.6,
        method: 'put',
        transformFile: this.transformFile,
        autoProcessQueue: false,
        thumbnailWidth: 350,
        maxFilesize: 50,
        headers: { "Content-Type": "image/jpeg" },
        sending: (file, xhr) => {
          var _send = xhr.send;
          xhr.send = () => {
            _send.call(xhr, this.resizedFiles[file.UniqueId]);
          };
        }
      },
      literals: {
        Ё: "YO",
        Й: "I",
        Ц: "C",
        Њ: "NJ",
        У: "U",
        Љ: "LJ",
        љ: "lj",
        Ѕ: "Z",
        ѕ: "z",
        Ѓ: "GJ",
        ѓ: "gj",
        Ќ: "KJ",
        ќ: "kj",
        Џ: "DJ",
        џ: "dj",
        К: "K",
        Ј: "J",
        Е: "E",
        Н: "N",
        Г: "G",
        Ш: "SH",
        Щ: "SCH",
        З: "Z",
        Х: "H",
        Ъ: "'",
        ё: "yo",
        й: "i",
        ц: "c",
        њ: "nj",
        у: "u",
        к: "k",
        е: "e",
        н: "n",
        г: "g",
        ш: "sh",
        щ: "sch",
        з: "z",
        х: "h",
        ъ: "'",
        Ф: "F",
        Ы: "I",
        В: "V",
        А: "a",
        П: "P",
        Р: "R",
        О: "O",
        Л: "L",
        Д: "D",
        Ж: "Z",
        Э: "E",
        ф: "f",
        ы: "i",
        в: "v",
        а: "a",
        п: "p",
        р: "r",
        о: "o",
        л: "l",
        д: "d",
        ж: "z",
        э: "e",
        Я: "Ya",
        Ч: "CH",
        С: "S",
        М: "M",
        И: "I",
        Т: "T",
        Ь: "'",
        Б: "B",
        Ю: "YU",
        я: "ya",
        ч: "ch",
        ј: "j",
        с: "s",
        м: "m",
        и: "i",
        т: "t",
        ь: "'",
        б: "b",
        ю: "yu"
      },
      wizard: {
        uploading: false,
        step1: {
          file: null,
          valid: false
        },
        step2: {
          file: null,
          valid: false
        },
        step3: {
          file: null,
          valid: false
        }
      },
      blog: {
        Title: "",
        Description: "",
        MetaTitle: "",
        AuthorId: 0,
        CoverPhoto: null,
        MetaDescription: "",
        MetaAuthor: "",
        UrlTag: "", 
        IsActive: true,
        IsFeatured: true,
        MetaKeywords: [],
        Categories: [],
        Photos: []
      },
      touched: {
        blogTitle: false,
        blogDescription: false,
        blogPrice: false,
        blogUrl: false,
        blogMetaTitle: false,
        blogMetaDescription: false,
        blogMetaAuthor: false,
        blogAuthor: false
      },
      modelValidations: {
        blogTitle: {
          required: true,
          min: 5,
          max: 120
        },
        blogDescription: {
          required: true,
          min: 5,
          max: 550
        },
        blogUrl: {
          required: true,
          min: 5,
          max: 120
        },
        blogMetaTitle: {
          required: true,
          min: 5,
          max: 120
        },
        blogMetaDescription: {
          required: true,
          min: 5,
          max: 550
        },
        blogAuthor: {
          required: true,
          min: 1
        },
        blogMetaAuthor: {
          required: true,
          min: 1,
          max: 120
        }
      }
    };
  },
  watch: {
    blogTitle() {
      this.touched.blogTitle = true;
    },
    blogDescription() {
      this.touched.blogDescription = true;
    },
    blogUrl() {
      this.touched.blogUrl = true;
    },
    blogMetaTitle() {
      this.touched.blogMetaTitle = true;
    },
    blogMetaDescription() {
      this.touched.blogMetaDescription = true;
    },
    blogMetaAuthor() {
      this.touched.blogMetaAuthor = true;
    }
  },
  methods: {
    invalidateCdn () {
      if (this.isEdit) {
        cdnInvalidator.onBlogDeleteOrUpdate(this.blog)
      } else {
        cdnInvalidator.onBlogCreate()
      }
    },
    transformFile (file, done) {
      this.resizePhoto(file, file.type, 1920, 1080).then(resized => {
        fetch(resized)
        .then(res => res.blob())
        .then(blob => {
          file.UniqueId = 'rnd-' + (Math.floor(Math.random() * 999999) + 1)
          this.resizedFiles[file.UniqueId] = blob;
          done(blob)
        })
      })
    },
    vdropzoneFileAdded (files) {
      let promiseArray = Array.from(files).map(file => {
        let prefix = Math.floor(Math.random() * 9999) + 1000;
        return axios
          .get("api/S3/Upload/PresignedUrl", {
            params: { filename: file.name, prefix: prefix, type: 'blog' }
          })
          .then(response => {
            file.PublicUrl = response.data.PublicUrl
            file.Url = response.data.Url
          });
      });
      Promise.all(promiseArray).then(() => {
        this.$refs.myVueDropzone.processQueue()
      })
    },
    vdropzoneSuccess(file, response) {
      let photo = {
        Url: file.PublicUrl
      }
      this.blog.Photos.push(photo);
      this.$refs.myVueDropzone.removeFile(file)
    },
    deletePhoto(photo) {
      if (!this.isCoverPhoto(photo)) {
        this.blog.Photos.splice(this.blog.Photos.indexOf(photo), 1);
      }
    },
    copyLink(photo) {
      this.$copyText(photo.SocialThumbnail).then((e) => {
        this.$notify({
          message: "Photo url coppied",
          icon: "check_circle_outline",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success"
        });
      }, function (e) {
        this.$notify({
          message: `Photo url failed to copy: ${e}`,
          icon: "times",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "error"
        });
        console.log(e)
      })
    },
    transliterate(word) {
      return word
        .split("")
        .map(char => {
          return this.literals[char] || char;
        })
        .join("");
    },
    generateUrl(word) {
      return word
        .trim()
        .split(" ")
        .map(token => token.trim())
        .join("-")
        .toLowerCase()
        .replace(/(-)\1+/g, '$1');
    },
    generateKeywords(word) {
      let cyrilic = word
        .trim()
        .split(" ")
        .map(token => token.trim().toLowerCase())
        .filter(token => token.length > 2);
      let latin = cyrilic.map(w => this.transliterate(w));
      return cyrilic.concat(latin);
    },
    isCoverPhoto(photo) {
      if (!this.blog.CoverPhoto) {
        return false
      }
      return (
        (this.isEdit && photo.Id == this.blog.CoverPhoto.Id) ||
        (!this.isEdit && photo.Url == this.blog.CoverPhoto.Url)
      );
    },
    photoModalHide() {
      this.showPhotoWizard = false;
      this.resetWizard();
    },
    thumbChanged({ coordinates, canvas }) {
      var file = this.getBlobToFile(
        coordinates,
        canvas,
        `thumb.${this.editingPhoto.Name}`,
        this.editingPhoto.Type
      );
      this.wizard.step2.file = file;
    },
    socialThumbChanged({ coordinates, canvas }) {
      var file = this.getBlobToFile(
        coordinates,
        canvas,
        `thumb.social.${this.editingPhoto.Name}`,
        this.editingPhoto.Type
      );
      this.wizard.step3.file = file;
    },
    getBlobToFile(coordinates, canvas, fileName, fileType) {
      var dataUrl = canvas.toDataURL(fileType, 0.9);
      var blobData = this.dataURItoBlob(dataUrl);
      var blobToFile = new File([blobData], fileName, { type: fileType });
      return blobToFile;
    },
    dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.resetWizard();
      this.wizard.step1.file = files[0];
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        vm.imageRegular = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage: function() {
      this.resetWizard();
    },
    resetWizard() {
      this.imageRegular = "";
      this.wizard.uploading = false;
      this.wizardSaving = false;
      this.wizardNextDisabled = false;
      this.wizard.step1 = {
        file: null,
        valid: false
      };
      this.wizard.step2 = {
        file: null,
        valid: false
      };
      this.wizard.step3 = {
        file: null,
        valid: false
      };
    },
    validate() {
      this.saving = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          let url = "";
          let successMessage = "";
          let method;

          if (this.isEdit) {
            url = `api/Blog/${this.blogId}`;
            method = axios.put;
            successMessage = "Blog successfully updated";
          } else {
            url = "api/Blog";
            method = axios.post;
            successMessage = "Blog successfully created";
          }

          let payload = this.preparePayload()
          return method(url, payload)
            .then(() => {
              this.invalidateCdn()

              this.$notify({
                message: successMessage,
                icon: "check_circle_outline",
                horizontalAlign: "right",
                verticalAlign: "bottom",
                type: "success"
              });
              this.$router.go(-1);
            })
            .catch(errors => {
              errors.forEach(error => {
                this.$notify({
                  message: error,
                  icon: "error_outline",
                  horizontalAlign: "right",
                  verticalAlign: "bottom",
                  type: "danger"
                });
              });
            });
        }
      })
      .finally(() => {
        this.saving = false
      })
    },
    validateStep(step) {
      if (!this.wizard[step].file) {
        return false;
      }

      setTimeout(() => {
        this.wizard[step].valid = true;
      }, 100);

      if (step === "step3" && !this.wizard.uploading) {
        this.startUpload();
      }

      return true;
    },
    startUpload() {
      this.wizardSaving = true;
      this.wizard.uploading = true;
      let file1 = this.wizard.step1.file;
      let file2 = this.wizard.step2.file;
      let file3 = this.wizard.step3.file;
      let photo = {};
      let promiseArray = [];
      //var s3AxiosInstance = axios.create({});
      var s3AxiosInstance = axios.create({
        transformRequest: [
          (data, headers) => {
            delete headers.common.Authorization;
            return data;
          }
        ]
      });
      //delete s3AxiosInstance.defaults.headers.common["Authorization"];

      let prefix = Math.floor(Math.random() * 9999) + 1000;
      
      let promise2 = axios
        .get("api/S3/Upload/PresignedUrl", {
          params: { filename: file2.name, prefix: prefix, type: 'blog' }
        })
        .then(response => {
          return this.resizePhoto(file2, file2.type, 1024, 1024).then(resized => {
            let resizedThumbnailFile = this.dataURLtoFile(resized, file2.name);
            return s3AxiosInstance
            .put(response.data.Url, resizedThumbnailFile, {
              headers: {
                "Content-Type": file2.type
              }
            })
              .then(() => {
                this.editingPhoto.Thumbnail = response.data.PublicUrl;
              });
          })
        });

      let promise3 = axios
        .get("api/S3/Upload/PresignedUrl", {
          params: { filename: file3.name, prefix: prefix, type: 'blog' }
        })
        .then(response => {
          return this.resizePhoto(file3, file3.type, 1600, 838).then(resized => {
            let resizedThumbnailFile = this.dataURLtoFile(resized, file3.name);
            return s3AxiosInstance
            .put(response.data.Url, resizedThumbnailFile, {
              headers: {
                "Content-Type": file3.type
              }
            })
              .then(() => {
                this.editingPhoto.SocialThumbnail = response.data.PublicUrl;
              });
          })
        });

      promiseArray.push(promise2);
      promiseArray.push(promise3);

      Promise.all(promiseArray)
        .then(() => {
          this.setCoverPhoto(this.editingPhoto)
          this.resetWizard();
          this.showPhotoWizard = false;
          this.editingPhoto = null;
        })
        .finally(() => {
          this.wizard.uploading = false;
        });
    },
    setCoverPhoto(photo) {
      if (photo.Thumbnail) {
        this.blog.CoverPhoto = photo
      } else {
        this.editingPhoto = photo
        this.showPhotoCoverBtnLoader();

        var s3AxiosInstance = axios.create({
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization;
              return data;
            }
          ]
        });
        s3AxiosInstance
          .get(photo.Url, {
            responseType: 'arraybuffer'
          })
          .then(response => {
            let contentType = response.headers['Content-Type'] ? response.headers['Content-Type'] : 'image/jpeg';

            let buffer = new Buffer(response.data, 'binary');
            let base64 = buffer.toString('base64');
            base64 = `data:${contentType};base64,${base64}`
            let name = photo.Url.split("/").reverse()[0]

            // let f = new File(buffer, name, {type: contentType});
            // let f = this.dataURLtoFile(base64, name);
            // console.log(f);
            //this.resizePhoto(f, contentType).then(resized => {
              //console.log(resized);

              // this.editingPhoto.DataUrl = resized
              this.editingPhoto.DataUrl = base64
              this.editingPhoto.Name = name
              this.editingPhoto.Type = contentType
              this.showPhotoWizard = true
            //});
          })
            .finally(() => {
              this.hidePhotoCoverBtnLoader();
            })
      }
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    hidePhotoCoverBtnLoader () {
      this.showPhotoLoading = false;
      this.photoButtonLoaders[this.blog.Photos.indexOf(this.editingPhoto)] = false
    },
    showPhotoCoverBtnLoader () {
      this.showPhotoLoading = true;
      this.photoButtonLoaders[this.blog.Photos.indexOf(this.editingPhoto)] = true
    },
    isActiveChanged() {
      if (this.blog.IsActive === false) {
        this.blog.IsFeatured = false;
      }
    },
    blogTitleChanged() {
      this.blog.MetaTitle = this.blog.Title;
      let url = this.generateUrl(this.transliterate(this.blog.Title));
      this.blog.UrlTag = url;
      let keywords = this.generateKeywords(this.blog.Title);
      this.blog.MetaKeywords = [
        ...new Set(this.blog.MetaKeywords.concat(keywords))
      ];
    },
    blogDescriptionChanged() {
      this.blog.MetaDescription = this.blog.Description;
    },
    blogContentChanged (event, editor ) {
      const maxDescLength = 500;
      // if(this.blog.Description.length == 0) {
      const plainContent = editor.getContent({ format: "text" });
      this.blog.Description = plainContent.length > maxDescLength ? plainContent.substring(0, maxDescLength) :  plainContent;
      this.blog.MetaDescription = this.blog.Description;
      // }
    },
    authorChanged(authorId) {
      if (authorId) {
        let author = this.authors.filter(a => a.Id == authorId)[0]
        this.blog.MetaAuthor = `${author.FirstName} ${author.LastName}`
      }
    },
    metaKeywordInserted(value) {
      let transliterated = this.transliterate(value);
      if (this.blog.MetaKeywords.indexOf(transliterated) == -1) {
        this.blog.MetaKeywords.push(transliterated);
      }
    },
    resizePhoto(file, contentType, maxWidth, maxHeight) {
      return new Promise((resolve, reject) => {
        var canvas = document.createElement("canvas");
        var img = document.createElement("img");
        var reader = new FileReader();  
        reader.onload = function(e) {
          img.onload = function() {
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            var MAX_WIDTH = maxWidth; //1920;
            var MAX_HEIGHT = maxHeight; //1080;
            var width = img.width;
            var height = img.height;

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height;
                height = MAX_HEIGHT;
              }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            var dataurl = canvas.toDataURL(contentType);
            resolve(dataurl)
          }
          img.src = e.target.result
        }
        reader.readAsDataURL(file);
      })
    },
    preparePayload () {
      const withoutDataUrl = photo => {
        let copy = Object.assign({}, photo)
        delete copy.DataUrl
        return copy
      }

      let payload = Object.assign({}, this.blog)
      payload.Photos = payload.Photos.map(withoutDataUrl)
      if (payload.CoverPhoto) {
        payload.CoverPhoto = withoutDataUrl(payload.CoverPhoto)
      }
      return payload
    },
    formatStringLimit(value, limit) {
      return `${value && value.length || 0} / ${limit}`;
    }
  }
};
</script>

<style lang="css">
 .mt-20 {
   margin-top: 20px;
 }
.cropper {
   height: 380px;
   background: #DDD;
 }
 .preview-image .image-container{
   width: 100px;
 }
 .preview-image {
   margin-right: 20px;
   margin-bottom: 10px;
 }
 .photo-modal .modal-container {
  width: 860px;
  max-width: 100%;
  background: transparent;
  box-shadow: none;
 }
 .photo-modal .modal-body {
    width: 0;
    padding: 0;
    margin: 0;
    background: transparent;
 }
 .photo-modal .modal-header {
   padding: 0 !important;
 }
 .photo-modal .md-card-content {
   padding: 0 !important;
 }
 .vue-dropzone {
   border-radius: 6px;
   border: 2px dashed #e5e5e5;
 }
 .dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin: 0;
}
.md-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-image .image-container {
  width: 100px;
  height: 100px;
}
textarea {
  padding-left: 0 !important;
}
.mce-content-body{
  border: none !important;
  border-bottom: 1px solid #ccc !important;
}
.blog-buttons .md-button.md-just-icon {
  width: 30px;
  min-width: 30px;
  margin-left: 0;
}
.tox-tinymce-aux {
    z-index: 13400;
}
.md-field.md-focused .md-helper-text {
  bottom: -16px;
}
</style>
